module.exports = __webpack_public_path__ + "static/media/video-pleasant-ja.4cf66682.vtt";